const description = `The hierarchy diagram is a graphical representation of a hierarchical structure,
where nodes represent entities or concepts, and edges indicate parent-child relationships.
It is useful for visualizing organizational structures, taxonomies, or any system with a clear hierarchy.
`;

export default description;
